import script from "./BoosterCcsPeriodBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BoosterCcsPeriodBlock.vue?vue&type=script&setup=true&lang=js"

import "./BoosterCcsPeriodBlock.vue?vue&type=style&index=0&id=0bf4faf2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf4faf2"]])

export default __exports__